import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

// Footer component can be added here if needed
// import Footer from './Footer';

function MainLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {/* Outlet will render the matched child route element */}
        <Outlet /> 
      </main>
      {/* <Footer /> */}
    </div>
  );
}

export default MainLayout;